import {yupResolver} from '@hookform/resolvers/yup';
import {SaveOutlined} from '@mui/icons-material';
import {Box, Button, Grid, Typography} from '@mui/material';
import React, {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {i18n} from 'src/i18n';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import ubicacionEnumerators from 'src/modules/ubicacion/ubicacionEnumerators';
import {customButtonStyle, magicFlexBox} from 'src/theme/schemes/CustomTheme';
import SelectFormItem from 'src/view/shared/form/items/SelectFormItem';
import TagsFormItem from 'src/view/shared/form/items/TagsFormItem';
import FormWrapper, {FormButtons} from 'src/view/shared/styles/FormWrapper';
import UbicacionAutocompleteFormItem from 'src/view/ubicacion/autocomplete/UbicacionAutocompleteFormItem';
import * as yup from 'yup';

const schema = yup.object().shape({
  nombre: yupFormSchemas.stringArray(i18n('entities.ubicacion.fields.nombre'), {
    required: true,
  }),
  clasificacion: yupFormSchemas.enumerator(i18n('entities.ubicacion.fields.clasificacion'), {
    required: true,
    options: ubicacionEnumerators.clasificacion,
  }),
  ubicacionAsociada: yupFormSchemas.relationToOne(i18n('entities.ubicacion.fields.ubicacionAsociada'), {}),
  visibilidad: yupFormSchemas.enumerator(i18n('entities.ubicacion.fields.visibilidad'), {
    options: ubicacionEnumerators.visibilidad,
  }),
  parentLabel: yupFormSchemas.string(i18n('entities.ubicacion.fields.parentLabel'), {}),
  multi: yupFormSchemas.boolean('multi'),
});

function UbicacionFormMulti(props) {
  const record = props.record;

  const [initialValues] = useState(() => {
    return {
      nombre: [],
      clasificacion: record?.clasificacion || 'Area',
      ubicacionAsociada: record,
      visibilidad: record?.visibilidad || 'Visible',
      parentLabel: record?.label,
      multi: true,
    };
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues as any,
  });

  const onSubmit = (values) => {
    props.onSubmit(props.record?.id, values);
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  const parentLabel = form.watch('parentLabel');

  const {saveLoading, modal} = props;

  return (
    <FormWrapper>
      <FormProvider {...form}>
        <Grid>
          <Typography variant="h1">{parentLabel}</Typography>
        </Grid>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          style={
            {
              ...magicFlexBox,
              paddingBottom: 18,
              paddingRight: 18,
              overflow: 'auto',
            } as any
          }>
          <Box
            sx={
              {
                ...magicFlexBox,
                flexGrow: 1,
                bgcolor: 'background.paper',
              } as any
            }>
            <Grid spacing={2} container>
              <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
                <TagsFormItem
                  name="nombre"
                  disabled={props.disabled}
                  label={i18n('entities.ubicacion.fields.nombre')}
                  required={true}
                />
              </Grid>
              <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
                <SelectFormItem
                  name="clasificacion"
                  disabled={props.disabled}
                  label={i18n('entities.ubicacion.fields.clasificacion')}
                  options={ubicacionEnumerators.clasificacion.map((value) => ({
                    value,
                    label: i18n(`entities.ubicacion.enumerators.clasificacion.${value}`),
                  }))}
                  required={true}
                  menuPortalTarget={document.body}
                />
              </Grid>

              {form.watch('clasificacion') === 'Area' && (
                <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
                  <UbicacionAutocompleteFormItem
                    name="ubicacionAsociada"
                    disabled={props.disabled}
                    label={
                      i18n('entities.ubicacion.fields.ubicacionAsociada') +
                      ' a ' +
                      i18n(`entities.ubicacion.enumerators.clasificacion.${form.watch('clasificacion')}`)
                    }
                    onChange={(newUbicacionAsociada) => {
                      console.log('value changed ubicacionAsociada', newUbicacionAsociada);
                      form.setValue('parentLabel', newUbicacionAsociada?.label);
                    }}
                    required={false}
                    showCreate={!props.modal}
                    menuPortalTarget={document.body}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </form>
        {!props.disabled && (
          <FormButtons
            style={{
              flexDirection: modal ? 'row-reverse' : undefined,
            }}>
            <Button
              style={{
                width: props.drawer ? '100%' : 300,
                ...customButtonStyle,
                marginTop: '12px',
              }}
              variant="contained"
              color="secondary"
              disabled={saveLoading}
              type="button"
              onClick={form.handleSubmit(onSubmit)}
              startIcon={<SaveOutlined />}
              size="large">
              {i18n('common.save')}
            </Button>
          </FormButtons>
        )}
      </FormProvider>
    </FormWrapper>
  );
}

export default UbicacionFormMulti;
